import { render } from "./AnimateNumber.vue?vue&type=template&id=9695ed18"
import script from "./AnimateNumber.vue?vue&type=script&lang=js"
export * from "./AnimateNumber.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__